import { render } from "./ProductNoteTemplateForm.vue?vue&type=template&id=4f684757"
import script from "./ProductNoteTemplateForm.vue?vue&type=script&lang=js"
export * from "./ProductNoteTemplateForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__